import { c as _c } from "react/compiler-runtime";
import React from "react";
interface TabOption {
  readonly key: string;
  readonly label: string;
  readonly hasIndicator?: boolean | undefined;
  readonly panelId: string;
}
interface TabToggleProps {
  readonly options: readonly TabOption[];
  readonly activeKey: string;
  readonly onSelect: (key: string) => void;
  readonly fullWidth?: boolean | undefined; // New prop to control width
}
export const TabToggle: React.FC<TabToggleProps> = t0 => {
  const $ = _c(12);
  const {
    options,
    activeKey,
    onSelect,
    fullWidth: t1
  } = t0;
  const fullWidth = t1 === undefined ? false : t1;
  const t2 = `tw-flex tw-gap-x-1 ${fullWidth ? "tw-w-full" : "tw-w-auto"}`;
  let t3;
  if ($[0] !== activeKey || $[1] !== fullWidth || $[2] !== onSelect || $[3] !== options) {
    let t4;
    if ($[5] !== activeKey || $[6] !== fullWidth || $[7] !== onSelect) {
      t4 = option => <button key={option.key} onClick={() => onSelect(option.key)} role="tab" aria-selected={activeKey === option.key} aria-controls={option.panelId} className={`tw-whitespace-nowrap tw-px-2 tw-py-3 tw-text-sm tw-font-medium tw-border-b-2 tw-border-t-0 tw-border-x-0 tw-border-solid tw-bg-transparent tw-transition-all tw-duration-200 tw-relative ${fullWidth ? "tw-flex-1 tw-text-center tw-justify-center tw-flex" : ""} ${activeKey === option.key ? "tw-text-white tw-border-primary-300" : "tw-text-iron-500 desktop-hover:hover:tw-text-iron-200 tw-border-transparent"}`}>{option.label}{option.hasIndicator && <div className="tw-absolute tw-rounded-full -tw-right-1 tw-top-1 tw-bg-red tw-h-2 tw-w-2" />}</button>;
      $[5] = activeKey;
      $[6] = fullWidth;
      $[7] = onSelect;
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    t3 = options.map(t4);
    $[0] = activeKey;
    $[1] = fullWidth;
    $[2] = onSelect;
    $[3] = options;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[9] !== t2 || $[10] !== t3) {
    t4 = <div className={t2} role="tablist">{t3}</div>;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
};